module.exports = __webpack_public_path__ + "img/iconapp.bde26895.png";